import { render, staticRenderFns } from "./TaxonomyCreate.vue?vue&type=template&id=2b111c7a&"
import script from "./TaxonomyCreate.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports